// Category configuration with icons and colors
const CATEGORY_CONFIG = {
  digital: {
    name: 'Digital Copy',
    icon: `<svg width="24" height="30" viewBox="0 0 24 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8.25 29.125C8.25 28.5 8.25 27.875 8.25 27.25C8.25 26 8.25 24.75 8.25 23.5C8.25 22.375 7.5 21.625 6.375 21.625C4.625 21.625 2.875 21.625 1.125 21.625C1 21.625 0.875 21.625 0.75 21.625C0.75 21.5 0.75 21.375 0.75 21.25C0.75 16.75 0.75 12.25 0.75 7.625C0.75 5.875 2 4.625 3.75 4.625C8 4.625 12.25 4.625 16.625 4.625C18.375 4.625 19.625 5.875 19.625 7.625C19.625 13.75 19.625 19.875 19.625 26.125C19.625 27.875 18.375 29.125 16.625 29.125C14 29.125 11.375 29.125 8.625 29.125C8.5 29.125 8.5 29.125 8.25 29.125Z" fill="currentColor"/>
      <path d="M21.375 25.125C21.375 25 21.375 24.875 21.375 24.75C21.375 19 21.375 13.25 21.375 7.5C21.375 5.25 19.875 3.25 17.625 2.875C17.25 2.75 17 2.75 16.625 2.75C12.75 2.75 9 2.75 5.125 2.75C5 2.75 4.875 2.75 4.75 2.75C4.75 2.625 4.75 2.625 4.875 2.5C5.375 1.5 6.25 0.875 7.375 0.875C11.75 0.875 16.125 0.875 20.625 0.875C22.25 0.875 23.375 2.125 23.375 3.75C23.375 7.5 23.375 11.125 23.375 14.875C23.25 23.75 22.5 24.875 21.375 25.125Z" fill="currentColor"/>
      <path d="M1.625 23.5C3.125 23.5 4.875 23.5 6.5 23.5C6.5 25.125 6.5 26.75 6.5 28.375C4.875 26.75 3.125 25.125 1.625 23.5Z" fill="currentColor"/>
    </svg>`,
    colors: {
      active: {
        background: '#E84E801F',
        color: '#E84E80',
        borderColor: '#E84E80'
      },
      inactive: {
        background: 'transparent',
        color: 'rgb(var(--color-foreground))',
        borderColor: '#d1d1d1'
      }
    }
  },
  canvas: {
    name: 'Canvas Print',
    icon: `<svg width="27" height="22" viewBox="0 0 27 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M11.3573 10.9492C11.756 11.3479 12.1547 11.7466 12.5533 12.1452C12.8523 11.7466 13.251 11.4476 13.55 11.0489C13.849 11.4476 14.2477 11.7466 14.5467 12.1452C14.8457 11.7466 15.2444 11.4476 15.5434 11.0489C15.643 10.9492 15.7427 10.9492 15.942 10.9492C16.3407 11.2482 16.7394 11.4476 17.2377 11.6469C17.3374 11.7466 17.4371 11.8462 17.4371 11.9459C17.4371 15.1353 17.4371 18.3246 17.4371 21.514V21.6137C14.9454 21.6137 12.4537 21.6137 9.8623 21.6137C9.8623 21.514 9.8623 21.4143 9.8623 21.3147C9.8623 18.225 9.8623 15.1353 9.8623 12.0456C9.8623 11.8462 9.96197 11.7466 10.0616 11.6469C10.4603 11.5472 10.859 11.2482 11.3573 10.9492Z" fill="currentColor"/>
      <path d="M26.3081 16.1315C26.2085 16.0318 26.1088 15.9321 26.0091 15.9321C23.7168 13.9388 21.4244 11.9454 19.0324 10.0517C18.8331 9.85241 18.7334 9.65308 18.7334 9.35407C18.7334 8.05839 18.7334 6.66304 18.7334 5.36736C18.7334 5.26769 18.7334 5.16803 18.7334 5.06836C18.8331 5.06836 18.9327 5.06836 19.0324 5.06836C21.4244 5.06836 23.7168 5.06836 26.1088 5.06836C26.3082 5.06836 26.4078 5.16803 26.4078 5.36736C26.4078 8.9554 26.4078 12.4438 26.4078 16.0318C26.3082 15.8325 26.3081 15.9321 26.3081 16.1315ZM21.7234 7.16138C21.6238 7.06171 21.5241 6.96205 21.4244 6.96205C20.9261 6.76271 20.3281 6.86238 19.9294 7.26105C19.7301 7.46039 19.7301 7.65972 19.9294 7.85906C20.1287 8.05839 20.3281 8.05839 20.5274 7.85906C20.9261 7.56005 21.1254 7.65972 21.3248 8.15806C21.3248 8.25773 21.5241 8.45706 21.7234 8.45706C21.8231 8.45706 22.0224 8.3574 22.1221 8.15806C22.3214 7.65972 22.5208 7.56005 23.0191 7.85906C23.2184 7.95872 23.4178 7.95872 23.5175 7.85906C23.7168 7.65972 23.7168 7.46039 23.5175 7.36072C23.4178 7.26105 23.3181 7.16138 23.3181 7.16138C22.7201 6.66304 22.2218 6.76271 21.7234 7.16138ZM23.2184 9.85241C22.5208 9.45374 21.9228 9.45374 21.5241 9.85241C21.3248 10.0517 21.3248 10.2511 21.4244 10.4504C21.6238 10.6498 21.8231 10.6498 22.0224 10.4504C22.4211 10.1514 22.7201 10.2511 22.8198 10.7494C22.9194 10.9488 23.0191 11.1481 23.2184 11.1481C23.4178 11.1481 23.5175 10.9488 23.6171 10.7494C23.7168 10.3508 24.0158 10.2511 24.4145 10.4504C24.7135 10.6498 24.9128 10.6498 25.0125 10.4504C25.2118 10.2511 25.1121 10.0517 24.9128 9.75274C24.4145 9.45374 23.8165 9.45374 23.2184 9.85241Z" fill="currentColor"/>
      <path d="M9.7627 8.3583C9.7627 5.56761 9.7627 2.87658 9.7627 0.185547C12.2544 0.185547 14.8458 0.185547 17.3374 0.185547C17.3374 2.87658 17.3374 5.56761 17.3374 8.3583C17.2378 8.25864 17.1381 8.15897 17.0384 8.15897C15.9421 7.26196 14.8458 6.36495 13.8491 5.36827C13.6497 5.16894 13.5501 5.2686 13.3507 5.36827C12.2544 6.26528 11.158 7.26196 10.0617 8.15897C9.96203 8.25864 9.86236 8.25864 9.7627 8.3583ZM13.4504 2.1789C12.9521 2.1789 12.6531 2.27857 12.3541 2.57757C12.1547 2.77691 12.1547 2.97624 12.3541 3.17558C12.5534 3.37492 12.7527 3.37492 12.9521 3.17558C13.3507 2.87658 13.6497 2.97624 13.8491 3.47458C13.9487 3.57425 14.0484 3.77359 14.2477 3.77359C14.4471 3.77359 14.5467 3.67392 14.6464 3.47458C14.8458 2.97624 15.0451 2.87658 15.4438 3.17558C15.6431 3.37492 15.8424 3.27525 16.0418 3.17558C16.1414 2.97624 16.1414 2.77691 16.0418 2.57757C15.8424 2.27857 15.4438 2.1789 15.1448 2.1789C14.8458 2.1789 14.5467 2.47791 14.3474 2.47791C13.8491 2.47791 13.6497 2.27857 13.4504 2.1789Z" fill="currentColor"/>
      <path d="M0.693359 14.3376C0.693359 11.1482 0.693359 8.05851 0.693359 4.86914C3.18505 4.86914 5.67675 4.86914 8.26811 4.86914C8.26811 4.96881 8.26811 5.06848 8.26811 5.16814C8.26811 6.56349 8.26811 7.95884 8.26811 9.35419C8.26811 9.55353 8.16844 9.65319 8.06877 9.75286C7.3711 10.3509 6.67343 10.8492 6.07542 11.4472C5.97575 11.5469 5.87608 11.5469 5.67675 11.4472C5.37774 11.2479 5.07874 11.0485 4.87941 10.8492C4.68007 10.7495 4.5804 10.7495 4.38107 10.8492C3.28472 11.8459 2.08871 12.9422 0.992363 13.9389C0.892695 14.1382 0.793027 14.2379 0.693359 14.3376ZM5.77642 6.46383C5.67675 6.06515 4.77974 5.66648 4.18173 5.66648C3.28472 5.76615 2.58705 6.36416 2.48738 7.26117C2.28804 8.05851 2.68671 8.85585 3.38439 9.35419C3.9824 9.75286 4.87941 9.75286 5.27808 9.35419C4.2814 8.95552 3.88273 8.35751 4.08206 7.65984C4.08206 6.76283 4.68007 6.46383 5.77642 6.46383Z" fill="currentColor"/>
      <path d="M5.87629 12.7434C6.67363 12.0457 7.37131 11.4477 8.26832 10.75C8.26832 12.9427 8.26832 15.0357 8.26832 17.2284C8.16865 17.2284 8.06898 17.2284 7.96932 17.2284C5.67696 17.2284 3.3846 17.2284 1.09224 17.2284C0.793235 17.2284 0.693567 17.1287 0.793235 16.9294C0.793235 16.8297 0.793235 16.8297 0.793235 16.7301C0.793235 16.3314 0.693567 15.8331 0.892903 15.5341C0.99257 15.235 1.49091 14.936 1.78991 14.637C2.48759 13.74 3.48426 12.9427 4.38127 12.0457C4.48094 11.946 4.58061 11.946 4.68028 11.8463C5.07895 12.1453 5.47762 12.4444 5.87629 12.7434Z" fill="currentColor"/>
      <path d="M18.7334 17.2284C18.7334 15.0357 18.7334 12.9427 18.7334 10.75C21.2251 12.9427 23.8165 15.0357 26.3081 17.2284C23.8165 17.2284 21.3248 17.2284 18.7334 17.2284Z" fill="currentColor"/>
      <path d="M17.3374 10.9505C16.7394 10.5518 16.1414 10.2528 15.5434 9.95381C15.2444 10.2528 14.9454 10.6515 14.5467 11.0502C14.2477 10.6515 13.8491 10.3525 13.5501 9.95381C13.2511 10.3525 12.9521 10.6515 12.5534 11.0502C12.2544 10.6515 11.8557 10.3525 11.5567 9.95381C10.9587 10.2528 10.3607 10.6515 9.7627 10.9505C9.7627 10.4521 9.7627 9.95381 9.7627 9.45547C9.7627 9.3558 9.86236 9.3558 9.96203 9.25613C11.0584 8.25945 12.2544 7.26278 13.3507 6.36577C13.4504 6.2661 13.5501 6.2661 13.7494 6.36577C14.9454 7.36244 16.0418 8.35912 17.2378 9.3558C17.3374 9.45547 17.3374 9.45547 17.3374 9.55514C17.3374 10.0535 17.3374 10.4521 17.3374 10.9505Z" fill="currentColor"/>
    </svg>`,
    colors: {
      active: {
        background: '#01A9D41F',
        color: '#01A9D4',
        borderColor: '#01A9D4'
      },
      inactive: {
        background: 'transparent',
        color: 'rgb(var(--color-foreground))',
        borderColor: '#d1d1d1'
      }
    }
  },
  poster: {
    name: 'Light Up Frame',
    icon: `<svg width="24" height="30" viewBox="0 0 24 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M23.2128 0.0996678C23.7111 0.299003 23.9104 0.697674 23.9104 1.19601C23.9104 3.3887 23.9104 5.5814 23.9104 7.77409C23.9104 7.97342 23.8108 8.07309 23.7111 8.27242C21.9171 9.46844 20.1231 10.5648 18.1297 11.4618C18.03 11.5615 17.8307 11.5615 17.731 11.4618C16.834 11.1628 15.937 10.8638 15.04 10.5648C14.8407 10.4651 14.741 10.3654 14.6413 10.2658C13.9437 9.46844 13.3457 8.6711 12.8473 7.97342C12.349 7.27575 11.751 7.27575 11.153 7.97342C10.555 8.77076 10.0566 9.56811 9.45861 10.2658C9.35895 10.3654 9.15961 10.5648 9.05994 10.5648C8.16293 10.8638 7.26592 11.1628 6.36891 11.4618C5.67124 11.6611 5.4719 12.2591 5.87057 12.9568C6.26925 13.4551 6.56825 14.0532 6.96692 14.5515C4.57489 15.1495 2.28253 15.9468 0.0898438 17.3422C0.0898438 17.1429 0.0898438 17.0432 0.0898438 16.9435C0.0898438 11.6611 0.0898438 6.47841 0.0898438 1.19601C0.0898438 0.697674 0.189512 0.299003 0.787518 0C8.2626 0.0996678 15.7377 0.0996678 23.2128 0.0996678ZM6.46858 5.28239C7.06659 5.28239 7.6646 5.28239 8.2626 5.28239C8.86061 5.28239 9.25928 4.88372 9.25928 4.38538C9.25928 3.88704 8.86061 3.48837 8.2626 3.48837C7.06659 3.48837C5.87057 3.48837C4.57489 3.48837C4.47523 3.48837C4.07655 3.48837C3.97689 3.48837C3.57822 3.88704 3.57822 4.38538C3.57822 4.88372 3.97689 5.28239 4.47523 5.28239C5.1729 5.28239 5.87057 5.28239 6.46858 5.28239ZM17.6314 3.58804C17.0334 3.58804 16.4354 3.58804 15.8374 3.58804C15.2393 3.58804 14.8407 3.98671 14.8407 4.48505C14.8407 4.98339 15.2393 5.38206 15.8374 5.38206C17.0334 5.38206 18.2294 5.38206 19.5251 5.38206C20.1231 5.38206 20.5217 4.98339 20.5217 4.48505C20.5217 3.98671 20.1231 3.58804 19.6247 3.58804C18.8274 3.58804 18.2294 3.58804 17.6314 3.58804ZM5.1729 8.77076C5.37224 8.77076 5.57157 8.77076 5.87057 8.77076C6.36891 8.77076 6.76758 8.37209 6.76758 7.87375C6.76758 7.37541 6.36891 6.97674 5.87057 6.97674C5.37224 6.97674 4.97356 6.97674 4.47523 6.97674C4.07655 7.07641 3.67788 7.47508 3.67788 7.97342C3.67788 8.47176 4.07655 8.77076 4.57489 8.87043C4.77423 8.87043 4.97356 8.77076 5.1729 8.77076ZM18.8274 7.07641C18.628 7.07641 18.329 7.07641 18.1297 7.07641C17.6314 7.07641 17.2327 7.47508 17.2327 7.97342C17.2327 8.47176 17.6314 8.87043 18.1297 8.87043C18.628 8.87043 19.0267 8.87043 19.5251 8.87043C20.0234 8.87043 20.4221 8.47176 20.4221 7.97342C20.4221 7.47508 20.0234 7.07641 19.5251 7.07641C19.2261 7.07641 19.0267 7.07641 18.8274 7.07641Z" fill="currentColor"/>
      <path d="M23.9104 10.2656C23.9104 10.465 23.9104 10.5646 23.9104 10.6643C23.9104 16.744 23.9104 22.8238 23.9104 28.9035C23.9104 29.7008 23.6114 29.9998 22.814 29.9998C15.638 29.9998 8.46188 29.9998 1.2858 29.9998C0.488457 29.9998 0.189453 29.7008 0.189453 28.9035C0.189453 25.9135 0.189453 22.8238 0.189453 19.8337C0.189453 19.6344 0.289121 19.4351 0.488456 19.3354C2.58148 17.94 4.87384 17.043 7.26587 16.445C7.4652 16.445 7.56487 16.3454 7.7642 16.3454C7.7642 16.9434 7.7642 17.5414 7.7642 18.0397C7.7642 18.3387 7.7642 18.6377 7.7642 18.9367C7.7642 19.6344 8.26254 20.0331 8.96022 19.8337C9.85723 19.5347 10.8539 19.2357 11.7509 18.9367C11.9503 18.8371 12.1496 18.8371 12.2493 18.9367C13.1463 19.2357 14.0433 19.5347 15.04 19.8337C15.7376 20.0331 16.3356 19.7341 16.3356 18.9367C16.3356 17.94 16.3356 16.9434 16.3356 15.9467C16.3356 15.7474 16.4353 15.6477 16.535 15.4483C16.9336 14.8503 17.3323 14.352 17.731 13.754C17.8306 13.6543 17.9303 13.5547 18.03 13.5547C20.0233 12.6577 22.0167 11.5613 23.8107 10.3653C23.711 10.2656 23.8107 10.2656 23.9104 10.2656ZM11.9503 22.9234C12.6479 22.9234 13.3456 22.9234 14.0433 22.9234C15.7376 22.9234 17.5316 22.9234 19.226 22.9234C19.7243 22.9234 20.123 22.6244 20.123 22.1261C20.2227 21.7274 19.9237 21.2291 19.4253 21.1294C19.3257 21.1294 19.1263 21.1294 19.0267 21.1294C14.2426 21.1294 9.55822 21.1294 4.77417 21.1294C4.6745 21.1294 4.57484 21.1294 4.47517 21.1294C4.0765 21.1294 3.67782 21.5281 3.67782 21.9268C3.67782 22.3254 3.87716 22.7241 4.27583 22.8238C4.3755 22.8238 4.57484 22.8238 4.6745 22.8238C7.26587 22.9234 9.65789 22.9234 11.9503 22.9234ZM12.0499 24.7175C10.3556 24.7175 8.66121 24.7175 6.96686 24.7175C6.56819 24.7175 6.26919 24.9168 6.06985 25.2158C5.77085 25.8138 6.26919 26.4118 6.96686 26.4118C9.15955 26.4118 11.3522 26.4118 13.5449 26.4118C14.7409 26.4118 15.937 26.4118 17.2326 26.4118C17.6313 26.4118 17.9303 26.2125 18.1297 25.9135C18.4287 25.3155 17.9303 24.7175 17.2326 24.7175C15.4386 24.7175 13.7443 24.7175 12.0499 24.7175Z" fill="currentColor"/>
      <path d="M7.86426 12.8572C8.56193 12.6579 9.25961 12.3589 9.95728 12.1595C10.1566 12.0599 10.4556 11.8605 10.655 11.6612C11.1533 11.0632 11.552 10.4652 11.9506 9.86719C12.0503 9.96686 12.0503 10.0665 12.15 10.0665C12.5486 10.5649 12.8476 11.1629 13.346 11.6612C13.5453 11.8605 13.7447 12.0599 14.0437 12.1595C14.7413 12.4585 15.439 12.6579 16.1367 12.8572C15.738 13.4552 15.3393 14.0532 14.841 14.6512C14.6417 14.9502 14.542 15.2492 14.542 15.5483C14.542 16.2459 14.542 16.9436 14.542 17.7409C14.3427 17.6413 14.1433 17.6413 13.944 17.5416C13.4457 17.3423 12.9473 17.1429 12.449 17.0433C12.15 16.9436 11.851 16.9436 11.6516 17.0433C10.954 17.2426 10.2563 17.4419 9.55861 17.7409C9.55861 17.0433 9.55861 16.3456 9.55861 15.6479C9.55861 15.2492 9.45894 14.8506 9.15994 14.4519C8.6616 13.9536 8.3626 13.4552 7.86426 12.8572Z" fill="currentColor"/>
    </svg>`,
    colors: {
      active: {
        background: '#F182281F',
        color: '#F18228',
        borderColor: '#F18228'
      },
      inactive: {
        background: 'transparent',
        color: 'rgb(var(--color-foreground))',
        borderColor: '#d1d1d1'
      }
    }
  }
};

// Robust variant categorization
class VariantCategories {
  constructor() {
    this.productId = this.getProductId();
    this.init();
  }

  init() {
    this.setupCategories();
    this.setupObserver();
    this.setupEventListeners();
  }

  setupCategories() {
    const sizeFieldsets = document.querySelectorAll('.product-form__input--size-cards');
    
    sizeFieldsets.forEach(fieldset => {
      if (fieldset.querySelector('.variant-categories')) return;
      this.addCategoriesToFieldset(fieldset);
    });
  }

  addCategoriesToFieldset(fieldset) {
    const legend = fieldset.querySelector('legend');
    const variantCards = fieldset.querySelector('.size-variant-cards');
    
    if (!legend || !variantCards) return;
    
    const categoryButtons = document.createElement('div');
    categoryButtons.className = 'variant-categories';
    
    // Create buttons using the configuration
    Object.keys(CATEGORY_CONFIG).forEach(category => {
      const config = CATEGORY_CONFIG[category];
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'variant-category-btn';
      button.dataset.category = category;
      button.innerHTML = `
        <span class="category-icon">${config.icon}</span>
        <span class="category-name">${config.name}</span>
      `;
      
      categoryButtons.appendChild(button);
    });
    
    legend.parentNode.insertBefore(categoryButtons, legend.nextSibling);
    
    const cards = variantCards.querySelectorAll('.size-variant-card');
    cards.forEach((card, index) => {
      if (index === 0) {
        card.classList.add('variant-category-digital');
      } else if (index >= 1 && index <= 4) {
        card.classList.add('variant-category-canvas');
      } else if (index >= 5 && index <= 8) {
        card.classList.add('variant-category-poster');
      }
    });
    
    const savedCategory = localStorage.getItem(`size-category-${this.productId}`) || 'digital';
    this.activateCategory(categoryButtons, cards, savedCategory);
    
    categoryButtons.addEventListener('click', (e) => {
      if (e.target.classList.contains('variant-category-btn') || e.target.closest('.variant-category-btn')) {
        const button = e.target.classList.contains('variant-category-btn') ? e.target : e.target.closest('.variant-category-btn');
        const category = button.dataset.category;
        
        localStorage.setItem(`size-category-${this.productId}`, category);
        this.activateCategory(categoryButtons, cards, category);
      }
    });
  }

  activateCategory(categoryButtons, cards, category) {
    categoryButtons.querySelectorAll('.variant-category-btn').forEach(btn => {
      const btnCategory = btn.dataset.category;
      const config = CATEGORY_CONFIG[btnCategory];
      const isActive = btnCategory === category;
      const colors = isActive ? config.colors.active : config.colors.inactive;
      
      // Apply colors
      btn.style.backgroundColor = colors.background;
      btn.style.color = colors.color;
      btn.style.border = `1px solid ${colors.borderColor}`;
      btn.style.display = 'flex';
      
      // Update active state
      if (isActive) {
        btn.classList.add('active');
      } else {
        btn.classList.remove('active');
      }
    });
    
    // Handle Digital Copy category specially
    if (category === 'digital') {
      // Hide all variant cards
      cards.forEach(card => {
        //card.style.display = 'none';
        card.classList.remove('visible');
        card.classList.add('hidden');
      });
      
      // Automatically select the first variant (Digital Copy)
      const digitalCard = cards[0];
      if (digitalCard) {
        const radio = digitalCard.querySelector('input[type="radio"]');
        if (radio && !radio.checked) {
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    } else {
      // Show only variants for the selected category
      cards.forEach(card => {
        if (card.classList.contains(`variant-category-${category}`)) {
          //card.style.display = 'block';
          card.classList.add('visible');
          card.classList.remove('hidden');
        } else {
          //card.style.display = 'none';
          card.classList.remove('visible');
          card.classList.add('hidden');
        }
      });
    }
  }

  setupObserver() {
    const observer = new MutationObserver((mutations) => {
      let shouldReinitialize = false;
      
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === Node.ELEMENT_NODE) {
              if (node.classList && node.classList.contains('product-form__input--size-cards')) {
                shouldReinitialize = true;
              }
              if (node.querySelector && node.querySelector('.product-form__input--size-cards')) {
                shouldReinitialize = true;
              }
            }
          });
        }
      });
      
      if (shouldReinitialize) {
        setTimeout(() => {
          this.setupCategories();
        }, 50);
      }
    });
    
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  setupEventListeners() {
    document.addEventListener('shopify:section:load', () => {
      setTimeout(() => {
        this.setupCategories();
      }, 100);
    });
    
    if (window.PubSub) {
      window.PubSub.subscribe('variantChange', () => {
        setTimeout(() => {
          this.setupCategories();
        }, 100);
      });
    }
  }

  getProductId() {
    const productForm = document.querySelector('form[action*="/cart/add"]');
    if (productForm) {
      const variantInput = productForm.querySelector('input[name="id"]');
      if (variantInput) {
        const variantId = variantInput.value;
        return variantId.split('-')[0] || 'default';
      }
    }
    
    const urlMatch = window.location.pathname.match(/\/products\/([^\/]+)/);
    return urlMatch ? urlMatch[1] : 'default';
  }
}

document.addEventListener('DOMContentLoaded', () => {
  window.variantCategories = new VariantCategories();
});